import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { toursApiQueryKeys } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';
import toursApi from '@/features/dashboard/tours/api/toursApi.ts';

const useActivateTour = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (tourId) => toursApi.activateTour(tourId),
    onSuccess: (_, tourId) => {
      toast.success('Wyjazd został aktywowany');
      queryClient.invalidateQueries({
        queryKey: toursApiQueryKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: toursApiQueryKeys.byId(tourId),
      });
      queryClient.invalidateQueries({
        queryKey: toursApiQueryKeys.activationReadiness(tourId),
      });
    },
    onError: (error: Error) => {
      toast.error('Nie udało się aktywować wyjazdu', {
        description: error.message,
      });
    },
  });
};

export default useActivateTour;
